import { render } from "./CreateFacilityGroupModal.vue?vue&type=template&id=cdcb1338&ts=true"
import script from "./CreateFacilityGroupModal.vue?vue&type=script&lang=ts"
export * from "./CreateFacilityGroupModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__